/**
 * @license Codistica
 *
 * Copyright (c) 2020, Codistica and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * BUILD DATE: Fri Jul 10 2020 16:51:08 GMT+0200 (Central European Summer Time)
 */

/** @module core/modules/reg-exp-utils/escape */
import { REG_EXPS } from '../../../constants/reg-exps.js';
/**
 * @description Takes a string as input and returns a string whose RegExp reserved characters has been escaped.
 * @param {string} str - String to be escaped.
 * @returns {string} Escaped string.
 */

function escape(str) {
  return str.replace(REG_EXPS.REG_EXP_RESERVED, '\\$&');
}

export { escape };